import DualTimeTag from './DualTime';

export default DualTimeTag;
